import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMasterProfile } from "../../../../../models/resources/master/IProfile";

export interface IMasterProfileState {
    list?: IMasterProfile[];
    loading: boolean;
}

const initialState: IMasterProfileState = {
    loading: false,
};

export const masterProfilelList = createSlice({
    name: "masterProfilelList",
    initialState,
    reducers: {
        resetMasterProfileList: () => initialState,
        setLoadingProfileList: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setMasterProfileList: (state, action: PayloadAction<IMasterProfile[]>) => {
            state.list = action.payload;
        },
    },
});

export const {resetMasterProfileList, setLoadingProfileList, setMasterProfileList } = masterProfilelList.actions;

export default masterProfilelList.reducer;
